export default __webpack_public_path__ + "static/media/card.84a43fa7.png";